// Complete mock job data for standalone deployment
const mockJobsData = {
  jobs: [
    {
      id: 1,
      title: "Senior Frontend Developer",
      company: "TechCorp Solutions",
      location: "San Francisco, CA",
      type: "Full-time",
      experience: "3-5 years",
      salary: "$120k - $160k",
      description: "We are looking for an experienced frontend developer with expertise in React, TypeScript, and modern CSS frameworks. You'll work on cutting-edge web applications and collaborate with our talented team.",
      skills: ["React", "TypeScript", "JavaScript", "CSS", "HTML", "Redux"],
      industry: "technology"
    },
    {
      id: 2,
      title: "Full Stack Engineer",
      company: "StartupXYZ",
      location: "Remote",
      type: "Full-time",
      experience: "2-4 years",
      salary: "$90k - $130k",
      description: "Join our innovative team to build scalable web applications using Node.js, React, and cloud technologies. Great opportunity for growth and impact.",
      skills: ["Node.js", "React", "MongoDB", "AWS", "JavaScript", "Express"],
      industry: "technology"
    },
    {
      id: 3,
      title: "React Developer",
      company: "DigitalAgency Pro",
      location: "New York, NY",
      type: "Full-time",
      experience: "2-3 years",
      salary: "$80k - $110k",
      description: "Looking for a passionate React developer to create amazing user interfaces for our diverse client portfolio. Creative environment with modern tech stack.",
      skills: ["React", "JavaScript", "CSS", "HTML", "Redux", "Tailwind"],
      industry: "technology"
    },
    {
      id: 4,
      title: "Backend Developer",
      company: "CloudTech Inc",
      location: "Seattle, WA",
      type: "Full-time",
      experience: "3-6 years",
      salary: "$110k - $150k",
      description: "Seeking experienced backend developer to design and implement scalable server-side applications. Work with modern cloud infrastructure.",
      skills: ["Python", "Django", "PostgreSQL", "AWS", "Docker", "Redis"],
      industry: "technology"
    },
    {
      id: 5,
      title: "DevOps Engineer",
      company: "Infrastructure Labs",
      location: "Austin, TX",
      type: "Full-time",
      experience: "4-7 years",
      salary: "$130k - $170k",
      description: "Join our DevOps team to build and maintain cutting-edge CI/CD pipelines and cloud infrastructure. Automation and scalability focus.",
      skills: ["Docker", "Kubernetes", "AWS", "Jenkins", "Terraform", "Linux"],
      industry: "technology"
    },
    {
      id: 6,
      title: "Mobile App Developer",
      company: "AppWorks Studio",
      location: "Los Angeles, CA",
      type: "Full-time",
      experience: "2-5 years",
      salary: "$95k - $135k",
      description: "Create amazing mobile experiences for iOS and Android platforms. Work with React Native and modern mobile development tools.",
      skills: ["React Native", "JavaScript", "TypeScript", "iOS", "Android", "Redux"],
      industry: "technology"
    },
    {
      id: 7,
      title: "Data Scientist",
      company: "AI Analytics Co",
      location: "Boston, MA",
      type: "Full-time",
      experience: "3-6 years",
      salary: "$125k - $165k",
      description: "Apply machine learning and statistical analysis to solve complex business problems. Work with large datasets and cutting-edge AI tools.",
      skills: ["Python", "Machine Learning", "TensorFlow", "SQL", "Pandas", "NumPy"],
      industry: "technology"
    },
    {
      id: 8,
      title: "UI/UX Designer",
      company: "DesignHub Creative",
      location: "Portland, OR",
      type: "Full-time",
      experience: "2-4 years",
      salary: "$85k - $115k",
      description: "Design beautiful and intuitive user interfaces for web and mobile applications. Strong portfolio and user-centered design approach required.",
      skills: ["Figma", "Adobe XD", "UI Design", "UX Research", "Prototyping", "CSS"],
      industry: "design"
    },
    {
      id: 9,
      title: "Python Developer",
      company: "DataTech Solutions",
      location: "Chicago, IL",
      type: "Full-time",
      experience: "3-5 years",
      salary: "$100k - $140k",
      description: "Develop robust Python applications for data processing and automation. Work with Django, Flask, and various data science libraries.",
      skills: ["Python", "Django", "Flask", "SQL", "APIs", "PostgreSQL"],
      industry: "technology"
    },
    {
      id: 10,
      title: "JavaScript Engineer",
      company: "WebCraft Agency",
      location: "Miami, FL",
      type: "Full-time",
      experience: "2-4 years",
      salary: "$85k - $120k",
      description: "Build modern web applications using the latest JavaScript technologies. Strong focus on performance and user experience.",
      skills: ["JavaScript", "React", "Node.js", "Vue.js", "CSS", "HTML"],
      industry: "technology"
    }
  ]
};

// Enhanced skill patterns for CV analysis
const SKILL_PATTERNS = {
  'python': ['python', 'py', 'python3', 'django', 'flask'],
  'java': ['java', 'java8', 'java11', 'j2ee', 'spring', 'spring boot'],
  'javascript': ['javascript', 'js', 'es6', 'ecmascript', 'node.js', 'nodejs'],
  'typescript': ['typescript', 'ts'],
  'react': ['react', 'reactjs', 'react.js', 'react native'],
  'node.js': ['node', 'nodejs', 'node.js', 'express.js', 'expressjs'],
  'sql': ['sql', 'mysql', 'postgresql', 'oracle', 'pl/sql'],
  'aws': ['aws', 'amazon web services', 'ec2', 's3', 'lambda'],
  'docker': ['docker', 'container', 'containerization'],
  'kubernetes': ['kubernetes', 'k8s'],
  'machine learning': ['machine learning', 'ml', 'deep learning', 'ai', 'artificial intelligence'],
  'tensorflow': ['tensorflow', 'tf'],
  'css': ['css', 'css3', 'scss', 'sass'],
  'html': ['html', 'html5'],
};

const extractSkillsFromCV = (cvText) => {
  const foundSkills = new Set();
  const cvTextLower = cvText.toLowerCase();
  
  Object.entries(SKILL_PATTERNS).forEach(([skill, variations]) => {
    variations.forEach(variation => {
      if (cvTextLower.includes(variation.toLowerCase())) {
        foundSkills.add(skill);
      }
    });
  });
  
  return Array.from(foundSkills);
};

const extractExperienceFromCV = (cvText) => {
  const patterns = [
    /(\d+)\+?\s*years?\s*of\s*experience/i,
    /(\d+)\+?\s*years?\s*experience/i,
    /experience\s*:\s*(\d+)\+?\s*years?/i,
    /worked\s*for\s*(\d+)\+?\s*years?/i,
  ];

  let maxYears = 0;
  patterns.forEach(pattern => {
    const match = cvText.match(pattern);
    if (match && match[1]) {
      const years = parseInt(match[1]);
      if (years > maxYears) {
        maxYears = years;
      }
    }
  });

  return maxYears;
};

const calculateJobRelevance = (job, cvSkills, cvExperience, cvText) => {
  let score = 50; // Base score
  
  // Skill matching (40% weight)
  const matchingSkills = job.skills.filter(skill => 
    cvSkills.some(cvSkill => skill.toLowerCase().includes(cvSkill.toLowerCase()))
  );
  const skillScore = (matchingSkills.length / Math.max(job.skills.length, 1)) * 40;
  
  // Experience matching (30% weight)
  const requiredYears = parseInt(job.experience) || 3;
  let experienceScore = 0;
  if (cvExperience >= requiredYears) {
    experienceScore = 30;
  } else if (cvExperience >= requiredYears - 1) {
    experienceScore = 20;
  } else if (cvExperience >= requiredYears - 2) {
    experienceScore = 10;
  }
  
  // Industry fit (20% weight)
  const industryKeywords = {
    'technology': ['software', 'tech', 'it', 'developer', 'engineer', 'programming'],
    'design': ['design', 'ui', 'ux', 'creative', 'interface']
  };
  
  let industryScore = 10; // Default
  const industry = job.industry || 'technology';
  const keywords = industryKeywords[industry] || industryKeywords.technology;
  const foundKeywords = keywords.filter(keyword => cvText.toLowerCase().includes(keyword));
  industryScore = Math.min(20, 10 + (foundKeywords.length * 2));
  
  // Random factor for variety (10% weight)
  const randomFactor = Math.random() * 10;
  
  return Math.round(score + skillScore + experienceScore + industryScore + randomFactor);
};

export const uploadCV = async (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    
    reader.onload = (event) => {
      try {
        const cvText = event.target.result;
        
        // Extract skills and experience from CV
        const extractedSkills = extractSkillsFromCV(cvText);
        const extractedExperience = extractExperienceFromCV(cvText);
        
        // Calculate relevance scores for all jobs
        const jobsWithScores = mockJobsData.jobs.map(job => ({
          ...job,
          matchScore: calculateJobRelevance(job, extractedSkills, extractedExperience, cvText),
          match_score: calculateJobRelevance(job, extractedSkills, extractedExperience, cvText),
          companyLogo: '🏢',
          postedDate: '1 week ago',
          posted_date: '1 week ago',
          featured: false
        }));
        
        // Sort by match score and add featured status
        const sortedJobs = jobsWithScores
          .sort((a, b) => b.matchScore - a.matchScore)
          .map((job, index) => ({
            ...job,
            featured: index < 3 && job.matchScore >= 85
          }));
        
        // Simulate processing delay
        setTimeout(() => {
          resolve({
            success: true,
            data: {
              recommendations: sortedJobs,
              analysis: {
                skills: extractedSkills,
                experience: extractedExperience,
                skillContext: extractedSkills.reduce((acc, skill) => {
                  acc[skill] = { level: 0.8, context: 'found in CV' };
                  return acc;
                }, {}),
                industries: { technology: 1 },
                keyPhrases: [],
                projectComplexity: 0.7
              }
            }
          });
        }, 1500);
        
      } catch (error) {
        reject({
          success: false,
          error: 'Failed to process CV'
        });
      }
    };
    
    reader.onerror = () => {
      reject({
        success: false,
        error: 'Failed to read CV file'
      });
    };
    
    reader.readAsText(file);
  });
};

export const getJobRecommendations = async (cvAnalysis) => {
  // This function is no longer needed for standalone version
  return {
    success: true,
    data: mockJobsData.jobs.slice(0, 5)
  };
};
